import SidebarNavLink from '../common/SidebarNavLink';
import { Routes } from '../../utils/constants/routes';
import { Live, Preview, Upload } from '../../icons';
import { useAuthStore } from '../../stores/authStore';

export interface SideNavigationBarProps {
    type: 'requester' | 'ops' | 'admin' | 'vendor';
}

const SideNavigationBar = ({ type }: SideNavigationBarProps) => {
    const activePartner = useAuthStore((state) => state.activePartner);
    return (
        <nav>
            <SidebarNavLink link={Routes.SEARCH_BY_GLB} label="SearchGLB" key="6">
                <Upload />
            </SidebarNavLink>
            <SidebarNavLink link={Routes.PREVIEW} label="Preview" key="7">
                <Preview />
            </SidebarNavLink>
            {activePartner === 'flipkart' ? (
                <>
                    <SidebarNavLink link={Routes.GOLIVE} label="Golive" key="5">
                        <Live />
                    </SidebarNavLink>
                </>
            ) : null}
        </nav>
    );
};

export default SideNavigationBar;
